import React from "react";
import styles from "./Home.module.css";
import { GoogleLogin } from "react-google-login";
import { createProfile } from "../../actions/profile";
import { useDispatch } from "react-redux";
import { auth, provider, signInWithPopup } from "../../firebase";
import googleStyles from "./Login.module.css";
import "./Home.css";
import Button from "@material-ui/core/Button";

import { BsGoogle } from "react-icons/bs";
import { useHistory, useLocation } from "react-router-dom";

import HomeBanner from "../../images/home-banner-small.jpg";

const Home = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const firebaseLogin = () => {
    signInWithPopup(auth, provider)
      .then((result) => {
        console.log(auth);
        console.log(result);
      })
      .catch((err) => console.log(err.message));
  };
  const googleSuccess = async (res) => {
    console.log(res);
    const result = res?.profileObj;
    const token = res?.tokenId;
    dispatch(
      createProfile({
        name: result?.name,
        email: result?.email,
        userId: result?.googleId,
        phoneNumber: "",
        businessName: "",
        contactAddress: "",
        logo: result?.imageUrl,
        website: "",
      })
    );

    try {
      dispatch({ type: "AUTH", data: { result, token } });

      window.location.href = "/dashboard";
    } catch (error) {
      console.log(error);
    }
  };
  const googleError = (error) => {
    console.log(error);
    console.log("Google Sign In was unseccassful. Try again later");
  };

  return (
    <div>
      <div>
        <div className="home-banner">
          <h3>Sure Accounts</h3>
          <p>Manage all your Accounts at one place.</p>
          <img src={HomeBanner} />
        </div>

        <div className="google-btn-container">
          <GoogleLogin
            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
            render={(renderProps) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <button
                  className={googleStyles.googleBtn}
                  onClick={renderProps.onClick}
                  disabled={renderProps.disabled}
                >
                  <BsGoogle />
                  &nbsp; Login with Google
                </button>
                <br />
                {/* <button onClick={firebaseLogin}>FIREBASE GOOGLE</button> */}
                <br />

                <Button
                  // variant="contained"
                  className={googleStyles.googleBtn}
                  // color="info"
                  onClick={() => history.push("/login")}
                  // className={styles.login}
                >
                  LOGIN or REGISTER
                </Button>
              </div>
            )}
            onSuccess={googleSuccess}
            onFailure={googleError}
            cookiePolicy="single_host_origin"
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
